<template>
  <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-white/80 backdrop-blur-sm">
    <div class="flex flex-col items-center justify-center">
      
      <!-- Loader Container: Holds the spinner and the centered logo -->
      <div class="relative flex items-center justify-center w-32 h-32">
        <!-- Static Ring -->
        <div class="absolute inset-0 border-4 border-emerald-100 rounded-full"></div>
        
        <!-- Spinning Ring -->
        <div class="absolute inset-0 border-4 border-emerald-500 rounded-full border-t-transparent animate-spin"></div>
        
        <!-- Pulse Effect -->
        <div class="absolute inset-0 bg-emerald-500/5 rounded-full animate-ping"></div>

        <!-- Centered Logo -->
        <div class="relative z-10 w-20 h-20 bg-white rounded-full shadow-md flex items-center justify-center p-4">
          <img 
            :src="rochexIcon" 
            alt="Loading..." 
            class="w-full h-full object-contain animate-pulse-slow"
          />
        </div>
      </div>

      <!-- Loading Text -->
      <div class="mt-8 font-medium text-lg text-emerald-700 animate-pulse">{{ message }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import rochexIcon from '@/assets/rochexicon.jpeg'

withDefaults(defineProps<{
  message?: string
}>(), {
  message: 'Loading...'
})
</script>

<style scoped>
.animate-pulse-slow {
  animation: pulse-slow 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse-slow {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}
</style>
